<!-- Desktop: campo compatto -->
<button
  type="button"
  class="gs-trigger d-none d-md-flex"
  (click)="open()"
  aria-label="Cerca (Ctrl+K)"
>
  <mat-icon class="gs-trigger-icon">search</mat-icon>
  <span class="gs-trigger-label">Cerca…</span>
  <span class="gs-trigger-kbd me-1">{{ shortcutLabel }}</span>
</button>

<!-- Mobile: solo icona -->
<button
  mat-icon-button
  class="gs-trigger-mobile d-inline-flex d-md-none white"
  (click)="open()"
  aria-label="Cerca"
>
  <mat-icon>search</mat-icon>
</button>
